<template>
  <footer class="border-t border-gray-200 bg-white/50 backdrop-blur-sm">
    <div class="container mx-auto px-4 py-8">
      <div class="grid md:grid-cols-4 gap-8">
        <!-- Logo和描述 -->
        <div>
          <div class="flex items-center gap-2 mb-4">
            <span class="text-3xl">🦊</span>
            <span class="font-bold text-psychology-primary">动物性格测试</span>
          </div>
          <p class="text-sm text-gray-600">
            通过60道精心设计的题目，分析你的七维度性格特征，为你匹配25种动物原型中最符合你的那一个。
          </p>
        </div>

        <!-- 测试相关 -->
        <div>
          <h4 class="font-semibold mb-3">测试相关</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <router-link to="/assessment/start" class="hover:text-psychology-primary">开始测试</router-link>
            </li>
            <li>
              <router-link to="/history" class="hover:text-psychology-primary">历史记录</router-link>
            </li>
            <li>
              <router-link to="/guide" class="hover:text-psychology-primary">测试说明</router-link>
            </li>
          </ul>
        </div>

        <!-- 资源 -->
        <div>
          <h4 class="font-semibold mb-3">资源</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <router-link to="/guide" class="hover:text-psychology-primary">测试说明</router-link>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">隐私政策</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">关于我们</a>
            </li>
          </ul>
        </div>

        <!-- 帮助 -->
        <div>
          <h4 class="font-semibold mb-3">帮助</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <a href="#" class="hover:text-psychology-primary">常见问题</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">使用技巧</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">反馈建议</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="border-t border-gray-200 mt-8 pt-8 text-center text-sm text-gray-600">
        <p>© 2025 动物性格测试. 趣味性格测试工具，仅供娱乐和自我了解使用。</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

